<div>
  <app-text-input
    titleClass="text-body-s font-medium"
    title="Adventure name (required)"
    id="title"
    placeholder="Type your adventure name"
    [control]="publishForm.controls['title']"
    inputClass="border-[1px] border-[#3A557C] rounded-100 mt-1"
    [errorMessages]="{
      NotFound: 'THis item was not found blabla',
      minlength: 'THiasdasdadd'
    }"
  />

  <app-text-area-input
    titleClass="text-body-s font-medium"
    title="Adventure description (required)"
    id="description"
    placeholder="Type your adventure description"
    [control]="publishForm.controls['description']"
    inputClass="border-[1px] border-[#3A557C] rounded-100 mt-1"
  />
  <app-button (click)="onSubmit()">Submit</app-button>
</div>

<div class="w-full gap-x-10 gap-y-4 flex-col md:flex-row flex justify-between">
  <!-- /*Mature Content */ -->
  <label
    class="group toggle cursor-pointer text-body-s font-medium flex w-full items-center justify-between"
  >
    <p>Contains mature content</p>

    <input type="checkbox" name="mature" id="mature" />
  </label>

  <!-- /*Mature Content */ -->

  <app-toggle
    header="Violence"
    [formControl]="publishForm.controls['violence']"
    [errorMessages]="{
      NotFound: 'THIS IS REQUIRED'
    }"
  />

  <a [routerLink]="dynamicLink.path" [queryParams]="dynamicLink.queryParams"
    >This is a url</a
  >
  <app-toggle header="Mature" [formControl]="publishForm.controls['mature']" />
</div>
